<template>
  <div class="left-sidebar">
    <div class="left-sidebar__top">
      <div class="aspace-between aalign-center">
        <!-- <img src="/img/logos/alfathedulogo.svg" alt="" /> -->
        <img src="/img/logos/alfathbelajarlogo.svg" alt="" />
        
        <img
          src="/img/icons/menu.svg"
          alt=""
          class="c-pointer"
          @click="$emit('menuClick')"
        />
      </div>
    </div>
    <div class="left-sidebar__bottom">
      <div class="menu mt-3 mb-4" v-if="isLoggedIn && tryout.id > 0 && $route.name !== 'tryout-history'">
        <div class="menu__level1">
          <template>
            <div
              class="menu__item"
              @click="startTryout"
            >
              <div class="aalign-center">
                <fa-icon icon="play-circle" class="mr-1"></fa-icon>
                <span class="mr-2">{{tryout.name}}</span>
                <div
                  class="arrow-right"
                  :class="{ 'rotate-90': expanded }"
                  style="right: 7px;"
                ></div>
              </div>
            </div>
           
            <b-collapse v-model="expanded">
              <div
                class="menu__level3"
                v-for="(item, k) in tryout.package"
                :key="k"
              >
                <b-link
                  :to="'/tryout/'+tryout.id+'/package/'+item.id"
                  class="menu__item"
                  event=""
                >
                  <fa-icon :icon="['far', 'copy']" class="mr-1">
                  </fa-icon>
                  {{ item.name }} <br />
                  <div class="menu__info">
                    {{ item.time_limit }} menit, {{ item.total_question }} soal
                  </div>

                  <!-- <img
                    src="/img/icons/free.svg"
                    alt="free"
                    class="menu__free"
                    v-if="!item.pay"
                  /> -->
                </b-link>
              </div>
            </b-collapse>
          </template>
        </div>
      </div>
      <div class="menu mt-3 mb-4" v-else>
        <div class="menu__level1" >
          <b-link
            class="menu__item"
            disabled
          >
            <fa-icon :icon="['far', 'play-circle']" class="mr-1"></fa-icon>
            TRYOUT
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {
      expanded: true
    };
  },
  methods: {
    handleLinkClick() {
      if (window.innerWidth < 768) {
        this.$emit("menuClick");
      }
    },
    startTryout() {
      this.$router.push("/tryout/"+this.tryout.id);
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN,
      tryout: types.TRYOUT
    })
  }
};
</script>

<style>
.left-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.left-sidebar__top {
  height: 87px;
  background-image: url("/img/backgrounds/ornament.svg");
  background-size: 100% 100%;
  padding: 20px 27px;
}

.left-sidebar__bottom {
  overflow-y: auto;
  height: calc(100vh - 155px);
  padding: 0 6px;
}

.menu__level1 .menu__item {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  color: #009feb;
  padding: 17px 27px;
  cursor: pointer;
  display: block;
}

.menu__level1 .menu__item:hover {
  text-decoration: none;
}

.menu__level1 .router-link-active {
  background-color: #e2f6ff;
  border-top: 1px solid #009feb;
  border-bottom: 1px solid #009feb;
}

.menu__level2 .menu__item {
  font-size: 14px;
  color: #0c2846;
  padding: 13px 50px;
  display: block;
}

.menu__level2 .router-link-active {
  background-color: #e2f6ff;
  border-top: 1px solid #009feb;
  border-bottom: 1px solid #009feb;
}

.menu__level3 .menu__item {
  color: #0c2846;
  font-weight: normal;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  position: relative;
  padding: 13px 50px;
}

.menu__free {
  position: absolute;
  right: 7px;
  top: 14px;
  z-index: 999;
}

.menu__level3 .menu__item:hover {
  background-color: #e2f6ff;
}

.menu__level3 .router-link-active {
  background-color: #e2f6ff;
  border-top: 1px solid #009feb;
  border-bottom: 1px solid #009feb;
}

.menu__level3 .menu__info {
  font-size: 11px;
  color: #b4b4b4;
  padding: 5px 22px;
  padding-bottom: 0;
  line-height: 1;
}
</style>
